import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { Image, IImageProps, IImageStyles, ImageFit } from '@fluentui/react/lib/Image';
import { LEGACY_DEFAULT_MIN_ASSET_WIDTH } from '../constants';

const imageStyles: Partial<IImageStyles> = {
    root: {
        margin: '-20px -20px 12px -20px', // These margins allow the hero image to touch the borders of the asset box.
        borderTopLeftRadius: 4,
        borderTopRightRadius: 4,
    },
};

type AssetImageProps = Omit<
    IImageProps,
    'styles' | 'theme' | 'imageFit' | 'width' | 'height' | 'draggable'
>;

export default observer(function AssetImage(props: AssetImageProps) {
    return (
        <Image
            styles={imageStyles}
            imageFit={ImageFit.cover}
            width={LEGACY_DEFAULT_MIN_ASSET_WIDTH}
            height={128}
            draggable={false}
            {...props}
        />
    );
});
